export default __webpack_public_path__ + "static/media/ellipse_testimony_two.97712806.svg";